import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { CuttingList } from '../TitleList';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectBalelist, selectChanllanId, selectClothIsInfo, selectClothIssue, selectContractorMemo, selectFirm, selectItemAvg, selectItems, selectMasterMlist, selectMemoNo, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';
import { fetchSOnoInfolist, fetchSORegister } from '../../Store/PHPSlice/Sale/SaleOrder';
import { fetchChanllanId, fetchClothIssueData, fetchClothIssueInfo, fetchClothStkBale, InsertCuttingEntry } from '../../Store/PHPSlice/Cutting/clothIssue';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { errorStyles } from '../../Utils/table';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchContractorMemo, fetchMasterMlist } from '../../Store/PHPSlice/Cutting/cuttingApi';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';


const ContCutEntry3 = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        firm: '',
        firmId: '',
        memo: '',
        sono: '0',
        empType: '2',//contractor
        ordType: '0',
        master: '',
        empNm: '',
        cloth: '',
        gMtr: '',
        rqMtr: '',
        bale: '',
        totQty: '0',
        item: '',
        noofmatch: '',
        mtch1: '',
        mtch2: '',
        mtch3: '',
        m1rqMtr: '',
        m2rqMtr: '',
        m3rqMtr: '',
        m1gMtr: '',
        m2gMtr: '',
        m3gMtr: '',
        instructions: '',
        soId: '',
        mpanna: '',
        m1panna: '',
        m2panna: '',
        m3panna: '',
        challanId: '',
        cIssueId: '',
        cltIssId: '',
        clothNm: '',
        mtch1Nm: '',
        mtch2Nm: '',
        mtch3Nm: '',
        itemNm: '',
        finalqty: 0,
        finalmtr: 0,
        bale: '',
        mbale: '',
        m1bale: '',
        m2bale: '',
        m3bale: '',
        userId: userdata?.ID,
        depart: ''
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        empNm: fetchClothStkBale,
        sono: fetchSORegister,
        firm: fetchCompanyData
        // Add more mappings if needed
    };
    const [manualItems, setManualItems] = useState([]);
    const [soFirm, setSoFirm] = useState([]);
    const [soCloth, setSoCloth] = useState([]);
    const [soMaster, setSoMaster] = useState([]);
    const [soItem, setSoItem] = useState([]);
    const [soQty, setSoQty] = useState([]);
    const [itemSize, setItemSize] = useState([]);
    const [itemMainAvgs, setItemMainAvgs] = useState([]);
    const [itemM1Avgs, setItemM1Avgs] = useState([]);
    const [itemM2Avgs, setItemM2Avgs] = useState([]);
    const [itemM3Avgs, setItemM3Avgs] = useState([]);
    const [errors, setErrors] = useState({});
    const [inputValues, setInputValues] = useState(Array(itemSize?.length).fill(''));
    const [matching1Values, setMatching1Values] = useState([]);
    const [matching2Values, setMatching2Values] = useState([]);
    const [matching3Values, setMatching3Values] = useState([]);
    const [mainValues, setMainValues] = useState([]);
    const [addItems, setAddItems] = useState([]);

    const [itemlistSO, setItemlistSO] = useState([]);
    const [selectSONOData, setSelectSONOData] = useState([]);

    const [multiData, setMultiData] = useState([]);
    const [soChallanlist, setSoChallanlist] = useState([]);
    const [soInfolist, setSoInfolist] = useState({});
    const [noBale, setNoBale] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [SOchallan, setSOchallan] = useState(false);
    const [clothState, setClothState] = useState(false);
    const [mclothBale, setMclothBale] = useState([]);
    const [m1clothBale, setM1clothBale] = useState([]);
    const [m2clothBale, setM2clothBale] = useState([]);
    const [m3clothBale, setM3clothBale] = useState([]);


    const dispatch = useDispatch();
    const solist = useSelector(selectSONOinfolist);

    const firmlist = useSelector(selectFirm);
    const balelist = useSelector(selectBalelist);
    const itemlist = useSelector(selectItems);
    const masterMlist = useSelector(selectMasterMlist);
    const clothIssuelist = useSelector(selectClothIssue);
    const clothIsinfolist = useSelector(selectClothIsInfo);
    const memoNo = useSelector(selectContractorMemo);
    const avglist = useSelector(selectItemAvg);
    const challanIdlist = useSelector(selectChanllanId);
    const departlist = useSelector(selectDaparement);

    useEffect(() => {
        dispatch(fetchClothStkBale());
        dispatch(fetchCompanyData());
        dispatch(fetchItemData());
        dispatch(fetchMasterMlist());
        dispatch(fetchClothIssueData());
        dispatch(fetchContractorMemo());
        dispatch(fetchClothIssueInfo());
        dispatch(fetchItemAvgData());
        dispatch(fetchChanllanId());
        dispatch(fetchDepartmentData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (memoNo.data) {
            const item = memoNo.data.con_memo;
            setFormData(prev => ({
                ...prev,
                memo: item
            }))
        }
    }, [memoNo]);

    useEffect(() => {
        if (clothIsinfolist?.data2?.item) {
            const dataval = clothIsinfolist?.data2?.item?.map((val) => {
                return { ID: val.itemId, itemNm: val.itemNm, cloths: val.info };
            });
            setManualItems(dataval);
            // console.log(dataval);
        }
    }, [clothIsinfolist?.data2?.item]);

    // useEffect(() => {
    //     if (formData.item !== "") {
    //         const selectcloth = manualItems
    //             ?.filter((val) => val.ID === formData.item)  // Filter by ID
    //             .map((vals) => vals.cloths)                   // Get the 'cloths' array
    //             .flat();                                    // Flatten the resulting array
    //         // const changeArr = selectcloth?.map((val) => {
    //         //     return { ID: val.clothId, clothNm: val.clothNm }
    //         // })
    //         const changeArr = selectcloth
    //             ?.reduce((acc, val) => {
    //                 // Check if clothId is already in the accumulator
    //                 if (!acc.some(item => item.ID === val.clothId)) {
    //                     acc.push({ ID: val.clothId, clothNm: val.clothNm, gMtr: val.gMtr, panna_size: val.panna_size });
    //                 }
    //                 return acc;
    //             }, []);
    //         setSoCloth(changeArr);
    //     }
    // }, [formData.item]);

    useEffect(() => {
        if (solist?.data?.length > 0) {
            const datavals = solist?.data;
            const itemlist = datavals?.map((item) => ({
                ID: item.itemId,
                itemNm: item.itemNm
            }));
            setManualItems(itemlist);
        }
        if (solist?.infoData) {
            setSoInfolist(solist?.infoData);
        }
    }, [solist]);

    useEffect(() => {
        if (inputValues.length > 0) {
            const totQtySum = inputValues.reduce((sum, qty) => sum + (isNaN(qty) ? 0 : parseFloat(qty)), 0);

            const filterMainAvg = itemMainAvgs?.length > 0 ? itemSize?.map((size) => {
                const matchedObj = itemMainAvgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const filterM1Avg = itemM1Avgs?.length > 0 ? itemSize?.map((size) => {
                const matchedObj = itemM1Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const filterM2Avg = itemM2Avgs?.length > 0 ? itemSize?.map((size) => {
                const matchedObj = itemM2Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const filterM3Avg = itemM3Avgs?.length > 0 ? itemSize?.map((size) => {
                const matchedObj = itemM3Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const maincalavg = mergeArrays(filterMainAvg, mainValues);
            const calMavg = inputValues.map((item, index) => parseFloat(item) * parseFloat(maincalavg[index]));
            const totalSum = calMavg.reduce((sum, qty) => sum + (isNaN(qty) ? 0 : qty), 0);

            const m1calavg = mergeArrays(filterM1Avg, matching1Values);
            const calM1avg = inputValues.map((item, index) => parseFloat(item) * parseFloat(m1calavg[index]));
            const totalSumM1 = calM1avg.reduce((sum, qty) => sum + (isNaN(qty) ? 0 : qty), 0);

            const m2calavg = mergeArrays(filterM2Avg, matching2Values);
            const calM2avg = inputValues.map((item, index) => parseFloat(item) * parseFloat(m2calavg[index]));
            const totalSumM2 = calM2avg.reduce((sum, qty) => sum + (isNaN(qty) ? 0 : qty), 0);

            const m3calavg = mergeArrays(filterM3Avg, matching3Values);
            const calM3avg = inputValues.map((item, index) => parseFloat(item) * parseFloat(m3calavg[index]));
            const totalSumM3 = calM3avg.reduce((sum, qty) => sum + (isNaN(qty) ? 0 : qty), 0);

            setTimeout(() => {
                setFormData(prev => ({
                    ...prev,
                    totQty: totQtySum.toFixed(2),
                    rqMtr: totalSum.toFixed(2),
                    m1rqMtr: totalSumM1.toFixed(2),
                    m2rqMtr: totalSumM2.toFixed(2),
                    m3rqMtr: totalSumM3.toFixed(2),
                }))
            }, 1000);
        }
    }, [inputValues, itemMainAvgs, itemM1Avgs, itemM2Avgs, itemM3Avgs, matching1Values, matching2Values, matching3Values]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleQtychange = (index, event) => {
        const { value } = event.target;
        const numericValue = parseFloat(value);

        // Validate the entered value against the corresponding soQty
        if (numericValue > soQty[index]) {
            alert(`Please enter a value equal to or less than ${soQty[index]}.`);

            // Resetting the input value to the previous valid value
            const newValues = [...inputValues];
            newValues[index] = '0'; // or you can reset it to the previous valid value if you store it
            setInputValues(newValues);

            // Refocus the input field after alert
            setTimeout(() => {
                const inputElement = document.getElementById(`input-${index}`);
                if (inputElement) {
                    inputElement.focus();
                }
            }, 0);
        } else {
            // If the value is valid, update the state
            const newValues = [...inputValues];
            newValues[index] = value;
            setInputValues(newValues);
        }
    };

    function aggregateData(data) {
        // Create a map to aggregate data by clothId
        const aggregatedData = data.reduce((acc, item) => {
            if (!acc[item.clothId]) {
                // Initialize entry if not exists
                acc[item.clothId] = {
                    ...item,
                    baleNo: [item.baleNo],
                    cIssueId: [item.cIssueId],
                    challanId: [item.challanId],
                    dt: [item.dt],
                    panna_size: item.panna_size,
                    totMtr: [item.totMtr],
                    gMtr: parseFloat(item.gMtr),
                    clothNm: item.clothNm
                };
            } else {
                // Aggregate gMtr and concatenate values if they are not the same
                acc[item.clothId].gMtr += parseFloat(item.gMtr);

                if (!acc[item.clothId].baleNo.includes(item.baleNo)) {
                    acc[item.clothId].baleNo.push(item.baleNo);
                }

                if (!acc[item.clothId].cIssueId.includes(item.cIssueId)) {
                    acc[item.clothId].cIssueId.push(item.cIssueId);
                }

                if (!acc[item.clothId].challanId.includes(item.challanId)) {
                    acc[item.clothId].challanId.push(item.challanId);
                }

                if (!acc[item.clothId].dt.includes(item.dt)) {
                    acc[item.clothId].dt.push(item.dt);
                }

                if (!acc[item.clothId].panna_size.includes(item.panna_size)) {
                    acc[item.clothId].panna_size.push(item.panna_size);
                }

                if (!acc[item.clothId].totMtr.includes(item.totMtr)) {
                    acc[item.clothId].totMtr.push(item.totMtr);
                }
            }
            return acc;
        }, {});

        // Convert the map to an array and format the aggregated data
        return Object.entries(aggregatedData).map(([clothId, item]) => ({
            clothId: clothId,
            baleNo: item.baleNo,
            cIssueId: item.cIssueId,
            challanId: item.challanId,
            dt: item.dt,
            panna_size: item.panna_size,
            totMtr: item.totMtr,
            gMtr: item.gMtr,
            clothNm: item.clothNm
        }));
    }

    function clothObj(ID, clothNm, panna_size) {
        const data = {
            ID: ID,
            clothNm: clothNm,
            panna_size: panna_size
        };
        return data;
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'cloth':
                if (value && formData.ordType === '0') {

                    const findItem = itemlist?.data?.length > 0 ? itemlist?.data?.find(val => val.ID === formData.item) : '';
                    if (findItem) {
                        const selectSizes = findItem?.size;
                        const splitArray = selectSizes.split(',');
                        setItemSize(splitArray);
                        const valuesLen = Array(splitArray.length).fill('0');
                        setInputValues(valuesLen);

                        const selectPannasize = soCloth?.find((val) => val.ID === value);
                        const pass_data = {
                            itemId: formData.item,
                            panna: selectPannasize?.panna_size,
                            key: 'avg'
                        };
                        fetchAvgsItemPanna(pass_data);

                        setFormData(prev => ({
                            ...prev,
                            gMtr: selectPannasize?.gMtr || '',
                            clothNm: selectPannasize?.clothNm || '',
                            mpanna: selectPannasize?.panna_size || ''
                        }));
                    }
                } else if (formData.ordType === '1' && value) {
                    fetchclothStkbalelist(value);
                    if (formData.ordType === '1') {
                        const data = {
                            sono: formData.sono,
                            item: formData.item
                        };
                        // console.log(soCloth);
                        fetchSOQty(data);
                    }

                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg'
                    };
                    fetchAvgsItemPanna(pass_data);


                    setFormData(prev => ({
                        ...prev,
                        gMtr: selectPannasize?.gMtr || '',
                        clothNm: selectPannasize?.clothNm || '',
                        mpanna: selectPannasize?.panna_size || ''
                    }));
                }
                break;
            case 'mtch1':
                if (value && formData.ordType === '0') {
                    const selectPannasize = soCloth?.find((val) => val.ID === value);

                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg1'
                    };
                    fetchAvgsItemPanna(pass_data);

                    setFormData(prev => ({
                        ...prev,
                        m1gMtr: selectPannasize?.gMtr || '',
                        mtch1Nm: selectPannasize?.clothNm || '',
                        m1panna: selectPannasize?.panna_size || ''
                    }));
                } else if (formData.ordType === '1' && value) {
                    fetchclothStkbalelist(value);
                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg1'
                    };
                    fetchAvgsItemPanna(pass_data);
                    setFormData(prev => ({
                        ...prev,
                        m1gMtr: selectPannasize?.gMtr || '',
                        mtch1Nm: selectPannasize?.clothNm || '',
                        m1panna: selectPannasize?.panna_size || ''
                    }));
                }
                break;

            case 'mtch2':
                if (value && formData.ordType === '0') {
                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg2'
                    };
                    fetchAvgsItemPanna(pass_data);
                    setFormData(prev => ({
                        ...prev,
                        m2gMtr: selectPannasize?.gMtr || '',
                        mtch2Nm: selectPannasize?.clothNm || '',
                        m2panna: selectPannasize?.panna_size || ''
                    }));
                } else if (formData.ordType === '1' && value) {
                    fetchclothStkbalelist(value);
                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg2'
                    };
                    fetchAvgsItemPanna(pass_data);

                    setFormData(prev => ({
                        ...prev,
                        m2gMtr: selectPannasize?.gMtr || '',
                        mtch2Nm: selectPannasize?.clothNm || '',
                        m2panna: selectPannasize?.panna_size || ''
                    }));
                }
                break;

            case 'mtch3':
                if (value && formData.ordType === '0') {
                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg3'
                    };
                    fetchAvgsItemPanna(pass_data);

                    setFormData(prev => ({
                        ...prev,
                        m3gMtr: selectPannasize?.gMtr || '',
                        mtch3Nm: selectPannasize?.clothNm || '',
                        m3panna: selectPannasize?.panna_size || ''
                    }));
                } else if (formData.ordType === '1' && value) {
                    fetchclothStkbalelist(value);
                    const selectPannasize = soCloth?.find((val) => val.ID === value);
                    const pass_data = {
                        itemId: formData.item,
                        panna: selectPannasize?.panna_size,
                        key: 'avg3'
                    };
                    fetchAvgsItemPanna(pass_data);

                    setFormData(prev => ({
                        ...prev,
                        m3gMtr: selectPannasize?.gMtr || '',
                        mtch3Nm: selectPannasize?.clothNm || '',
                        m3panna: selectPannasize?.panna_size || ''
                    }));
                }
                break;

            case 'item':
                if (formData.ordType === '0' && value) {
                    const selectItem = manualItems?.find(item => item.ID === value);
                    const clothlist2 = selectItem?.cloths;
                    const clothlist3 = clothlist2?.map((item) =>
                    ({
                        ID: item.clothId,
                        gMtr: item.gMtr,
                        panna_size: item.panna_size,
                        clothNm: item.clothNm
                    }));
                    // console.log(clothlist2);
                    setSoCloth(clothlist3);
                    setFormData(prev => ({
                        ...prev,
                        itemNm: selectItem?.itemNm || ''
                    }));
                } else if (formData.ordType === '1' && value) {

                    const selectItem = manualItems?.find(item => item.ID === value);
                    var itemNm = selectItem?.itemNm;

                    const clothlist2 = selectItem?.cloths;
                    const clothlist3 = clothlist2?.map((item) =>
                    ({
                        ID: item.clothId,
                        gMtr: item.gMtr,
                        panna_size: item.panna_size,
                        clothNm: item.clothNm
                    }));
                    // console.log(clothlist2);
                    // setSoCloth(clothlist3);
                    // console.log('hii');
                    //get cloths 
                    const postobj2 = {
                        cIssid: formData.challanId,
                        itemId: value
                    };

                    fetchClothsOnIssueItems(postobj2);

                    setFormData(prev => ({
                        ...prev,
                        itemNm: itemNm || ''
                    }));
                } else if (formData.ordType === '2' && value) {
                    const selectItem = manualItems?.find(item => item.ID === value);
                    var itemNm = selectItem?.itemNm;
                    const postobj = {
                        sono: formData.sono,
                        item: value
                    };
                    fetchSOQty(postobj);
                    // fetchSOQty(postobj);
                    setClothState(true);
                    const selectCloth = soInfolist[itemNm];
                    // console.log(selectCloth);

                    var mtcount = '0';
                    const clothlist = selectCloth?.data;
                    let cloths = [];
                    let mcloth = clothObj(clothlist?.mainClothId, clothlist?.mclothNm, clothlist?.mpana);
                    cloths.push(mcloth);
                    fetchMainClothBale(clothlist?.mainClothId);

                    // const findAvgs = avglist?.data?.length > 0 ? avglist?.data?.filter((val) => val.panna_size === clothlist?.mpana && val.itemId === value) : [];
                    // // console.log(findAvgs);
                    // const selectAvgs = findAvgs.length > 0 ? findAvgs.map((val) => val.avg) : [];
                    // setItemMainAvgs(selectAvgs);
                    const pass_data = {
                        itemId: value,
                        panna: clothlist?.mpana,
                        key: 'avg'
                    };
                    fetchAvgsItemPanna(pass_data);
                    if (clothlist?.m1Id !== '0') {
                        mtcount = '1';
                        let m1cloth = clothObj(clothlist?.m1Id, clothlist.m1clothNm, clothlist?.m1pana);
                        cloths.push(m1cloth);
                        fetchM1ClothBale(clothlist?.m1Id);

                        // const findAvgs1 = avglist?.data?.length > 0 ? avglist?.data?.filter((val) => val.panna_size === clothlist?.m1pana && val.itemId === value) : [];
                        // const selectAvgs1 = findAvgs1?.length > 0 ? findAvgs1?.map((val) => val.avg1) : [];
                        // setItemM1Avgs(selectAvgs1);
                        const pass_data2 = {
                            itemId: value,
                            panna: clothlist?.m1pana,
                            key: 'avg1'
                        };
                        fetchAvgsItemPanna(pass_data2);
                    }

                    if (clothlist?.m2Id !== '0') {
                        mtcount = '2';
                        let m2cloth = clothObj(clothlist?.m2Id, clothlist.m2clothNm, clothlist?.m2pana);
                        cloths.push(m2cloth);
                        fetchM2ClothBale(clothlist?.m2Id);

                        // const findAvgs2 = avglist?.data?.length > 0 ? avglist?.data?.filter((val) => val.panna_size === clothlist?.m2pana && val.itemId === value) : [];
                        // const selectAvgs2 = findAvgs2?.length > 0 ? findAvgs2?.map((val) => val.avg2) : [];
                        // setItemM2Avgs(selectAvgs2);

                        const pass_data3 = {
                            itemId: value,
                            panna: clothlist?.m2pana,
                            key: 'avg2'
                        };
                        fetchAvgsItemPanna(pass_data3);
                    }

                    if (clothlist?.m3Id !== '0') {
                        mtcount = '3';
                        let m3cloth = clothObj(clothlist?.m3Id, clothlist.m3clothNm, clothlist?.m3pana);
                        cloths.push(m3cloth);
                        fetchM3ClothBale(clothlist?.m3Id);

                        // const findAvgs3 = avglist?.data?.length > 0 ? avglist?.data?.filter((val) => val.panna_size === clothlist?.m3pana && val.itemId === value) : [];
                        // const selectAvgs3 = findAvgs3?.length > 0 ? findAvgs3?.map((val) => val.avg3) : [];
                        // setItemM2Avgs(selectAvgs3);

                        const pass_data4 = {
                            itemId: value,
                            panna: clothlist?.m3pana,
                            key: 'avg3'
                        };
                        fetchAvgsItemPanna(pass_data4);
                    }

                    // setSoCloth(cloths);

                    setFormData(prev => ({
                        ...prev,
                        cloth: clothlist?.mainClothId,
                        clothNm: clothlist?.mclothNm,
                        mpanna: clothlist?.mpana,
                        mtch1: clothlist.m1Id,
                        mtch1Nm: clothlist.m1clothNm,
                        m1panna: clothlist?.m1pana,
                        mtch2: clothlist.m2Id,
                        m2panna: clothlist.m2pana,
                        mtch2Nm: clothlist.m2clothNm,
                        mtch3: clothlist.m3Id,
                        mtch3Nm: clothlist.m3clothNm,
                        m3panna: clothlist?.m3pana,
                        noofmatch: mtcount,
                        itemNm: itemNm || ''
                    }));


                }
                break;
            case 'empNm':
                if (value) {
                    if (formData.ordType === '0') {
                        const selectedFirms = clothIssuelist.manualemp.length > 0 ? clothIssuelist.manualemp.filter((val) => val.masterId === value) : [];
                        if (selectedFirms.length > 0) {
                            const ids = selectedFirms.map(val => val.ID);
                            const clinfolist = clothIsinfolist.data.length > 0 ? clothIsinfolist.data.filter((item) => ids.includes(item.cIssueId)) : [];
                            const common = aggregateData(clinfolist)
                            // console.log(common)
                            setSoCloth(common);
                        }
                        const selectedClothIssue = clothIssuelist.manualemp.length > 0 ? clothIssuelist.manualemp[0] : [];
                        if (selectedClothIssue) {
                            const cltIssId = selectedClothIssue.ID;
                            setFormData(prev => ({
                                ...prev,
                                cltIssId: cltIssId
                            }));
                        }
                    } else if (formData.ordType === '1') {
                        const data = {
                            sono: formData.sono,
                            empId: value
                        };
                        fetchSOClothIssueData(data);
                    }
                }
                break;
            case 'sono':
                if (value) {

                    // fetchSOClothIssueData(value);
                    const selectSo = balelist?.cuttingSOnos?.find((item) => item.sono === value);
                    const soId = selectSo?.ID;
                    dispatch(fetchSOnoInfolist(value));
                    // if (formData.empNm) {

                    //     const data = {
                    //         sono: value,
                    //         empId: formData.empNm,
                    //         category: '2'
                    //     };
                    //     fetchSOClothIssueData(data);
                    // }

                    const data = {
                        sono: value,
                        empId: formData.empNm,
                        category: '2'
                    };
                    fetchSOClothIssueData(data);
                }
                break;
            case 'challanId':
                if (value) {
                    dispatch(fetchClothIssueData(value));
                    dispatch(fetchClothIssueInfo(value));
                    setSOchallan(true);
                    fetchSelectClothIssueData(value);
                    // if (formData.ordType === '0') {
                    //     const values = clothIssuelist?.data[0];
                    //     setFormData(prev => ({
                    //         ...prev,
                    //         cIssueId: values.ID,
                    //         empNm: values.masterId,
                    //         empname: values.empNm
                    //     }));
                    // }
                } else {
                    setSOchallan(false);
                }
                break;

            case 'ordType':
                if (value) {
                    setSOchallan(false);
                    setFormData(prev => ({
                        ...prev,
                        empNm: '',
                        empname: '',
                        cIssueId: '',
                        challanId: '',
                        item: '',
                        itemNm: '',
                        cloth: '',
                        clothNm: '',
                        soId: '',
                        sono: ''
                    }));
                }
                break;
            case 'depart':
                if (value) {
                    fetchEmployeesDepart(value);
                }
                break;
            default:
                break;
        }
    };


    const fetchClothsOnIssueItems = async (id) => {
        const { cIssid, itemId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothsOnIssueandItems&cIssid=${cIssid}&itemId=${itemId}`);
            const res = response?.data?.data;
            // console.log(res);
            setSoCloth(res);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchSelectClothIssueData = async (id) => {

        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothIssuelist&cIssueId=${id}`);
            const res = response?.data?.data[0];
            // console.log(res);
            setFormData(prev => ({
                ...prev,
                cIssueId: res.ID,
                empNm: res.masterId,
                empname: res.empNm,
                firmId: res.firm
            }));

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };
    // console.log(clothIsinfolist);
    const fetchSOClothIssueData = async (id) => {
        const { sono, empId, category } = id;
        try {
            // const response = await axios.get(`${baseUrl}?apicall=getClothIssueInfolist&sono=${sono}&empId=${empId}`);
            const response = await axios.get(`${baseUrl}?apicall=getClothIssueInfolist&sono=${sono}&category=${category}`);
            const challan_values = response?.data?.data;
            // console.log(challan_values);
            setSoChallanlist(challan_values);
            setFormData(prev => ({
                ...prev,
                firmId: challan_values[0]?.firm
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchSOQty = async (id) => {
        const { sono, item } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSOqtyCutting&sono=${sono}&item=${item}`);
            // console.log(response.data);
            const clothlist = response?.data?.cloth || [];
            // console.log(clothlist);

            const values = response?.data?.data;
            const soqty = values?.map(item => item.soqty);
            const itemSizes = values?.map(item => item.size);


            setSoQty(soqty);
            setItemSize(itemSizes);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchclothStkbalelist = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothStkBales&clothId=${id}`);
            setNoBale(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchMainClothBale = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothStkBales&clothId=${id}`);
            setMclothBale(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchM1ClothBale = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothStkBales&clothId=${id}`);
            setM1clothBale(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchM2ClothBale = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothStkBales&clothId=${id}`);
            setM2clothBale(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchM3ClothBale = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothStkBales&clothId=${id}`);
            setM3clothBale(response?.data?.data);
            // console.log(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchAvgsItemPanna = async (id) => {
        const { itemId, panna, key } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getAvgsItemPanna&itemId=${itemId}&panna=${panna}`);
            // console.log(response.data);
            const getAvg = response?.data?.data;
            // console.log(getAvg)
            if (key === 'avg') {
                const filterAvg = getAvg?.map(item => ({
                    avg: item[key],
                    size: item.size
                }));
                setItemMainAvgs(filterAvg);
            } else if (key === 'avg1') {
                const filterAvg2 = getAvg?.map(item => ({
                    avg: item[key],
                    size: item.size
                }));
                setItemM1Avgs(filterAvg2);
            } else if (key === 'avg2') {
                const filterAvg3 = getAvg?.map(item => ({
                    avg: item[key],
                    size: item.size
                }));
                setItemM2Avgs(filterAvg3);
            } else if (key === 'avg3') {
                const filterAvg4 = getAvg?.map(item => ({
                    avg: item[key],
                    size: item.size
                }));
                setItemM3Avgs(filterAvg4);
            }
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const fetchEmployeesDepart = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getEmpDepartContractor&depart=${id}`);
            setSoMaster(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleMainValuesChange = (index, e) => {
        const updatedValues = [...mainValues];
        updatedValues[index] = e.target.value;
        setMainValues(updatedValues);
    };

    const handleMatching1Change = (index, e) => {
        const updatedValues = [...matching1Values];
        updatedValues[index] = e.target.value;
        setMatching1Values(updatedValues);
    };

    const handleMatching2Change = (index, e) => {
        const updatedValues = [...matching2Values];
        updatedValues[index] = e.target.value;
        setMatching2Values(updatedValues);
    };

    const handleMatching3Change = (index, e) => {
        const updatedValues = [...matching3Values];
        updatedValues[index] = e.target.value;
        setMatching3Values(updatedValues);
    };

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
            master: '',
            firm: '',
            cloth: '',
            item: '',
            noofmatch: '',
            sono: '',
            totQty: '',
            rqMtr: '',
            gMtr: '',
            m1gMtr: '',
            m1rqMtr: '',
            m2gMtr: '',
            m2rqMtr: '',
            m3gMtr: '',
            m3rqMtr: '',
            mtch1: '',
            mtch2: '',
            mtch3: '',
        });
        setInputValues([]);
        setMatching1Values([]);
        setMatching2Values([]);
        setMatching3Values([]);
        setItemM1Avgs([]);
        setItemM2Avgs([]);
        setItemM3Avgs([]);
        setItemMainAvgs([]);
        setSoQty([]);
        setItemSize([]);
    };

    const handleMultiItems = () => {

        if (formData.empNm.trim() === "") {
            alert('Select Master');
        } else {

            const values = [formData.gMtr, formData.m1gMtr, formData.m2gMtr, formData.m3gMtr];

            const filterMainAvg = itemMainAvgs?.length > 0 ? itemSize?.map((size, index) => {
                const matchedObj = itemMainAvgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const filterM1Avg = itemM1Avgs?.length > 0 ? itemSize?.map((size, index) => {
                const matchedObj = itemM1Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];

            const filterM2Avg = itemM2Avgs?.length > 0 ? itemSize?.map((size, index) => {
                const matchedObj = itemM2Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];



            const filterM3Avg = itemM3Avgs?.length > 0 ? itemSize?.map((size, index) => {
                const matchedObj = itemM3Avgs?.find(obj => obj.size === size);
                const avgs = matchedObj?.avg;
                return avgs;
            }) : [];


            const filterSolist = balelist?.cuttingSOnos?.filter(item => item.sono !== formData.sono);
            const filterItems = manualItems?.filter(val => val.ID !== formData.item);
            setManualItems(filterItems);
            const filterItems2 = manualItems?.filter(val => val.ID === formData.item);
            setAddItems(prev => [...prev, ...filterItems2]);


            const duplicat_multidata = [...multiData];

            const totqty = parseInt(formData.totQty, 10) + duplicat_multidata?.reduce((acc, sum) => acc + parseFloat(sum.totQty || 0), 0);
            // console.log(totqty);

            // Convert valid numeric values and sum them up
            const totmtr = values
                .map(value => parseFloat(value)) // Convert to float
                .filter(value => !isNaN(value)) // Remove NaN values (empty, null, or invalid numbers)
                .reduce((acc, curr) => acc + curr, 0); // Sum remaining values
            // console.log(totmtr);

            const muldata = {
                itemId: formData.item,
                itemNm: formData.itemNm,
                cloth: formData.cloth,
                mreq: formData.rqMtr,
                mtch1: formData.mtch1,
                m1req: formData.m1rqMtr,
                mtch2: formData.mtch2,
                m2req: formData.m2rqMtr,
                mtch3: formData.mtch3,
                m3req: formData.m3rqMtr,
                ordType: formData.ordType,
                clothNm: formData.clothNm,
                mtch1Nm: formData.mtch1Nm,
                mtch2Nm: formData.mtch2Nm,
                mtch3Nm: formData.mtch3Nm,
                mgMtr: formData.gMtr,
                m1gMtr: formData.m1gMtr,
                m2gMtr: formData.m2gMtr,
                m3gMtr: formData.m3gMtr,
                totQty: formData.totQty,
                itemSize: itemSize,
                soQty: soQty,
                itemMainAvgs: mergeArrays(filterMainAvg, mainValues),
                itemM1Avgs: mergeArrays(filterM1Avg, matching1Values),
                itemM2Avgs: mergeArrays(filterM2Avg, matching2Values),
                itemM3Avgs: mergeArrays(filterM3Avg, matching3Values),
                qtyArr: inputValues,
                mpanna: formData.mpanna,
                m1panna: formData.m1panna,
                m2panna: formData.m2panna,
                m3panna: formData.m3panna,
                tableData: tableData,
                sono: formData.sono,
                totmtr: totmtr,
                challanId: formData.challanId
            };
            setMultiData((prev) => [...prev, muldata]);
            setFormData(prev => ({
                ...prev,
                item: '',
                itemNm: '',
                cloth: '',
                rqMtr: '',
                mtch1: '',
                mtch2: '',
                mtch3: '',
                m1rqMtr: '',
                m2rqMtr: '',
                m3rqMtr: '',
                clothNm: '',
                mtch1Nm: '',
                mtch2Nm: '',
                mtch3Nm: '',
                m1gMtr: '',
                m2gMtr: '',
                m3gMtr: '',
                gMtr: '',
                totQty: '0',
                noofmatch: '',
                finalqty: totqty,
                mpanna: '',
                m1panna: '',
                m2panna: '',
                m3panna: '',
                finalmtr: parseFloat(prev.finalmtr) + totmtr
            }));

            setItemSize([]);
            setItemMainAvgs([]);
            setItemM1Avgs([]);
            setItemM2Avgs([]);
            setItemM3Avgs([]);
            setSoQty([]);
            setInputValues([]);
            setTableData([]);
            // setSoChallanlist([]);
            setSOchallan(false);
            setClothState(false);
        }
    };

    const handleDeleteItem = (data) => {
        const updateItems = addItems?.filter(item => item.ID === data?.itemId);
        setManualItems(prev => [...prev, ...updateItems]);

        const updatedData = multiData?.filter(item => item !== data);
        setMultiData(updatedData);
    }


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const noofMatching = [
        { label: 'Matching 1', value: '1' },
        { label: 'Matching 2', value: '2' },
        { label: 'Matching 3', value: '3' },
    ];

    function mergeArrays(a, b) {
        return a.map((valueA, index) => {
            const valueB = b[index];

            // Convert the values to numbers for comparison
            const numA = Number(valueA) || 0;
            const numB = Number(valueB) || 0;

            // Check the conditions
            if (numA !== 0 && numB === 0) {
                return valueA;
            } else if (numA === 0 && numB !== 0) {
                return valueB;
            } else if (numA !== 0 && numB !== 0) {
                return valueA; // You can choose either valueA or valueB here since both are non-zero
            } else {
                return '0'; // Both are zero
            }
        });
    };

    function convertIntoOneObject(formData, multiData) {
        const data = {
            dt: formData.dt,
            ordType: formData.ordType,
            memo: formData.memo,
            empType: formData.empType,
            empId: formData.empNm,
            instruction: formData.instructions,
            userId: formData.userId,
            finalqty: formData.finalqty,
            finalmtr: formData.finalmtr,
            multiData: multiData,
            firmId: formData.firmId
        };
        return data;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        const finalObj = convertIntoOneObject(formData, multiData);
        // console.log(finalObj);

        dispatch(InsertCuttingEntry(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cutting Added");
                alert("Cutting Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };


    const dropdownlistChallan = [
        {
            label: 'Challan No',
            id: 'challanId',
            options: challanIdlist?.data2 || [],
            value: formData.challanId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'challanId', value: newValue ? newValue.ID : '' } }, 'challanId'),
            getOptionLabel: (option) => option.challanId || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const dropdownlistChallanSO = [
        {
            label: 'Challan No',
            id: 'challanId',
            options: soChallanlist || [],
            value: formData.challanId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'challanId', value: newValue ? newValue.ID : '' } }, 'challanId'),
            getOptionLabel: (option) => option.challanId || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const dropdownlistfirst = [
        {
            label: 'Item',
            id: 'item',
            options: manualItems,
            value: formData.item,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleEmployeeNew = () => {
        window.open(`/new-employee-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownEmployeelist = [
        {
            label: 'Master',
            id: 'empNm',
            options: soMaster || [],
            value: formData.empNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empNm', value: newValue ? newValue.ID : '' } }, 'empNm'),
            getOptionLabel: (option) => option.empNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleEmployeeNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('empNm'),
            handleDropdownClose: () => handleDropdownClose('empNm'),
        }
    ];

    const dropdownClothlist = [
        {
            label: 'Main Cloth',
            id: 'cloth',
            options: soCloth,
            value: formData.cloth,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'cloth', value: newValue ? newValue.ID : '' } }, 'cloth'),
            getOptionLabel: (option) => option.clothNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownBale = [
        {
            label: 'Bale',
            id: 'bale',
            options: noBale || [],
            value: formData.bale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'bale', value: newValue ? newValue.ID : '' } }, 'bale'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownDepartment = [
        {
            label: 'Department',
            id: 'depart',
            options: departlist?.data?.filter((item) => item.departNm === 'CUTTING' || item.departNm === 'CUT-TO-PACK') || [],
            value: formData.depart,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'depart', value: newValue ? newValue.ID : '' } }, 'depart'),
            getOptionLabel: (option) => option.departNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleAddClick = () => {
        if (noBale?.length > 0 && formData.bale !== '') {
            const selectbale = noBale?.find((val) => val.ID === formData.bale);

            // Only use soCloth to find clothinfo
            const clothinfo = soCloth.length > 0 ? soCloth.find((val) => val.ID === selectbale.clothId) : '';

            var txt = '';
            if (formData.cloth === selectbale.clothId) {
                txt = 'Main Cloth';
            } else if (formData.mtch1 === selectbale.clothId) {
                txt = 'M1 Cloth';
            } else if (formData.mtch2 === selectbale.clothId) {
                txt = 'M2 Cloth';
            } else if (formData.mtch3 === selectbale.clothId) {
                txt = 'M3 Cloth';
            }

            if (clothinfo) {
                const table = {
                    baleId: selectbale.ID,
                    baleNo: selectbale.bale,
                    baleMtr: selectbale.bmtr,
                    givenMtr: selectbale.bmtr,
                    clothId: selectbale.clothId,
                    clothNm: selectbale.clothNm,
                    ClothType: txt
                };
                const updatedTableData = [...tableData, table];
                setTableData(updatedTableData);

                const totalGivenMtr = updatedTableData.reduce((total, item) => {
                    return total + (Number(item.givenMtr) || 0);
                }, 0);

                const updateBalelist = noBale.filter((val) => val.ID !== selectbale.ID);

                const filterBale = updateBalelist.filter(bale =>
                    !updatedTableData.some(item => item.baleId === bale.ID)
                );
                setNoBale(filterBale);
                setFormData(prev => ({
                    ...prev,
                    bale: ''
                }));

            } else {
                alert('Cloth information not found in soCloth');
            }
        } else {
            alert('Select the Bale No');
        }
    };

    const handleBaleAddClick = (name) => {
        switch (name) {
            case 'Main Cloth':
                if (mclothBale?.length > 0 && formData.mbale !== '') {
                    const selectbale = mclothBale?.find((val) => val.ID === formData.mbale);

                    const table = {
                        baleId: selectbale.ID,
                        baleNo: selectbale.bale,
                        baleMtr: selectbale.bmtr,
                        givenMtr: selectbale.bmtr,
                        clothId: selectbale.clothId,
                        clothNm: selectbale.clothNm,
                        ClothType: 'Main Cloth'
                    };
                    const updatedTableData = [...tableData, table];
                    setTableData(updatedTableData);

                    const bales = {
                        bale: selectbale.bale
                    };
                    const updatedBales = [noBale, bales];
                    setNoBale(updatedBales);

                    const updateBalelist = mclothBale.filter((val) => val.ID !== selectbale.ID);

                    const filterBale = updateBalelist.filter(bale =>
                        !updatedTableData.some(item => item.baleId === bale.ID)
                    );
                    setMclothBale(filterBale);
                    setFormData(prev => ({
                        ...prev,
                        mbale: ''
                    }));
                } else {
                    alert('Select the Main cloth Bale No');
                }
                break;

            case 'M1 Cloth':
                if (m1clothBale?.length > 0 && formData.m1bale !== '') {
                    const selectbale = m1clothBale?.find((val) => val.ID === formData.m1bale);

                    const table = {
                        baleId: selectbale.ID,
                        baleNo: selectbale.bale,
                        baleMtr: selectbale.bmtr,
                        givenMtr: selectbale.bmtr,
                        clothId: selectbale.clothId,
                        clothNm: selectbale.clothNm,
                        ClothType: 'M1 Cloth'
                    };
                    const updatedTableData = [...tableData, table];
                    setTableData(updatedTableData);

                    const bales = {
                        bale: selectbale.bale
                    };
                    const updatedBales = [noBale, bales];
                    setNoBale(updatedBales);
                    const updateBalelist = m1clothBale.filter((val) => val.ID !== selectbale.ID);

                    const filterBale = updateBalelist.filter(bale =>
                        !updatedTableData.some(item => item.baleId === bale.ID)
                    );
                    setM1clothBale(filterBale);
                    setFormData(prev => ({
                        ...prev,
                        m1bale: ''
                    }));
                } else {
                    alert('Select the M1 cloth Bale No');
                }
                break;

            case 'M2 Cloth':
                if (m2clothBale?.length > 0 && formData.m2bale !== '') {
                    const selectbale = m2clothBale?.find((val) => val.ID === formData.m2bale);

                    const table = {
                        baleId: selectbale.ID,
                        baleNo: selectbale.bale,
                        baleMtr: selectbale.bmtr,
                        givenMtr: selectbale.bmtr,
                        clothId: selectbale.clothId,
                        clothNm: selectbale.clothNm,
                        ClothType: 'M2 Cloth'
                    };
                    const updatedTableData = [...tableData, table];
                    setTableData(updatedTableData);

                    const bales = {
                        bale: selectbale.bale
                    };
                    const updatedBales = [noBale, bales];
                    setNoBale(updatedBales);

                    const updateBalelist = m2clothBale.filter((val) => val.ID !== selectbale.ID);

                    const filterBale = updateBalelist.filter(bale =>
                        !updatedTableData.some(item => item.baleId === bale.ID)
                    );
                    setM2clothBale(filterBale);
                    setFormData(prev => ({
                        ...prev,
                        m2bale: ''
                    }));
                } else {
                    alert('Select the M2 cloth Bale No');
                }
                break;

            case 'M3 Cloth':
                if (m3clothBale?.length > 0 && formData.m3bale !== '') {
                    const selectbale = m3clothBale?.find((val) => val.ID === formData.m3bale);

                    const table = {
                        baleId: selectbale.ID,
                        baleNo: selectbale.bale,
                        baleMtr: selectbale.bmtr,
                        givenMtr: selectbale.bmtr,
                        clothId: selectbale.clothId,
                        clothNm: selectbale.clothNm,
                        ClothType: 'M3 Cloth'
                    };
                    const updatedTableData = [...tableData, table];
                    setTableData(updatedTableData);

                    const bales = {
                        bale: selectbale.bale
                    };
                    const updatedBales = [noBale, bales];
                    setNoBale(updatedBales);

                    const updateBalelist = m3clothBale.filter((val) => val.ID !== selectbale.ID);

                    const filterBale = updateBalelist.filter(bale =>
                        !updatedTableData.some(item => item.baleId === bale.ID)
                    );
                    setM3clothBale(filterBale);
                    setFormData(prev => ({
                        ...prev,
                        m3bale: ''
                    }));
                } else {
                    alert('Select the M3 cloth Bale No');
                }
                break;

            default:
                break;
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            setSelectedRows(tableData.map((_, index) => index));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (index, isChecked) => {
        if (isChecked) {
            setSelectedRows([...selectedRows, index]);
        } else {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        }
    };

    const calculateBalanceMtr = (stockMtr, givenMtr) => {
        const stock = parseFloat(stockMtr);
        const given = parseFloat(givenMtr);
        if (!isNaN(stock) && !isNaN(given)) {
            return (stock - given).toFixed(2);
        }
        return stockMtr;
    };

    const fields = [
        { label: 'Master', name: 'empname', type: 'readOnly' }
    ];

    const dropdownMainClothBale = [
        {
            label: 'Main Bale',
            id: 'mbale',
            options: mclothBale?.filter(bale => !noBale.some(item => item.bale === bale.bale)) || [],
            value: formData.mbale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'mbale', value: newValue ? newValue.ID : '' } }, 'mbale'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleBaleAddClick('Main Cloth'),
            btnlabel: 'Add'
        }
    ];

    const dropdownM1ClothBale = [
        {
            label: 'M1 Bale',
            id: 'm1bale',
            options: m1clothBale?.filter(bale => !noBale.some(item => item.bale === bale.bale)) || [],
            value: formData.m1bale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'm1bale', value: newValue ? newValue.ID : '' } }, 'm1bale'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleBaleAddClick('M1 Cloth'),
            btnlabel: 'Add'
        }
    ];

    const dropdownM2ClothBale = [
        {
            label: 'M2 Bale',
            id: 'm2bale',
            options: m2clothBale?.filter(bale => !noBale.some(item => item.bale === bale.bale)) || [],
            value: formData.m2bale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'm2bale', value: newValue ? newValue.ID : '' } }, 'm2bale'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleBaleAddClick('M2 Cloth'),
            btnlabel: 'Add'
        }
    ];

    const dropdownM3ClothBale = [
        {
            label: 'M3 Bale',
            id: 'm3bale',
            options: m3clothBale?.filter(bale => !noBale.some(item => item.bale === bale.bale)) || [],
            value: formData.m3bale,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'm3bale', value: newValue ? newValue.ID : '' } }, 'm3bale'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleBaleAddClick('M3 Cloth'),
            btnlabel: 'Add'
        }
    ];


    const ordlist = [
        { label: "Manual", ID: "0" },
        { label: "Cloth Challan SO", ID: "1" },
        { label: "Only Sale Order", ID: "2" }
    ];
    const dropdownOrdType = [
        {
            label: 'Order Type',
            id: 'ordType',
            options: ordlist || [],
            value: formData.ordType,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordType', value: newValue ? newValue.ID : '' } }, 'ordType'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }
    ];

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/cutting-item-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleLumpAdd = (id) => {
        window.open(`/ClothIssueLump/${id}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    }

    const handleRemoveClickSO = () => {
        if (selectedRows.length > 0) {
            // Get the rows that need to be removed based on selectedRows
            const rowsToRemove = selectedRows.map(index => tableData[index]);

            // Filter the table data to remove selected rows
            const updatedTableData = tableData.filter((_, index) => !selectedRows.includes(index));

            // Update the bale list by adding the removed bales back
            const updatedBaleList = [...noBale, ...rowsToRemove.map(row => ({
                ID: row.baleId,
                bale: row.baleNo,
                bmtr: row.baleMtr,
                clothId: row.clothId
            }))];

            // Update the soCloth list by adding the removed cloths back
            const updatedSoClothList = [...soCloth, ...rowsToRemove.map(row => ({
                ID: row.clothId,
                clothNm: row.clothNm // Assuming clothNm was built from multiple properties
            }))];

            // Update the state
            setNoBale(updatedBaleList);
            setSoCloth(updatedSoClothList);
            setTableData(updatedTableData);
            setSelectedRows([]);

            // Update the total given meters in the form data
            const totalGivenMtr = updatedTableData.reduce((total, item) => {
                return total + (Number(item.givenMtr) || 0);
            }, 0);

            // setFormData(prev => ({
            //     ...prev,
            //     totMtr: totalGivenMtr
            // }));
        } else {
            alert('No rows selected to remove');
        }
    };

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {

            const bId = resendData?.baleId;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableData];

            const updatedData = updateTableData.map(item =>
                item.baleId === bId
                    ? { ...item, givenMtr: totmtr }
                    : item
            );
            setTableData(updatedData);

            // const maincloth = updatedData?.find(item => item.ClothType === 'Main Cloth').givenMtr;
            // const m1cloth = updatedData?.find(item => item.ClothType === 'M1 Cloth')?.givenMtr;
            // const m2cloth = updatedData?.find(item => item.ClothType === 'M2 Cloth')?.givenMtr;
            // const m3cloth = updatedData?.find(item => item.ClothType === 'M3 Cloth')?.givenMtr;

            const maincloth = updatedData?.filter(item => item.ClothType === 'Main Cloth')
                .reduce((total, item) => total + item.givenMtr, 0);

            const m1cloth = updatedData?.filter(item => item.ClothType === 'M1 Cloth')
                .reduce((total, item) => total + item.givenMtr, 0);

            const m2cloth = updatedData?.filter(item => item.ClothType === 'M2 Cloth')
                .reduce((total, item) => total + item.givenMtr, 0);

            const m3cloth = updatedData?.filter(item => item.ClothType === 'M3 Cloth')
                .reduce((total, item) => total + item.givenMtr, 0);

            // console.log(maincloth, m1cloth, m2cloth, m3cloth);

            setFormData(prev => ({
                ...prev,
                gMtr: maincloth || '',
                m1gMtr: m1cloth || '',
                m2gMtr: m2cloth || '',
                m3gMtr: m3cloth || ''
            }));

            // const totalMtr = updatedData.reduce((acc, row) => acc + parseFloat(row.givenMtr), 0);
            // const item_tot = itemsData.reduce((acc, item) => acc + parseFloat(item.totmtr), 0);
            // const final_tot = totalMtr + item_tot;
            // setFormData(prev => ({
            //     ...prev,
            //     totMtr: final_tot
            // }));
        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild3 = handleResend;

    const mcloths = [
        { label: 'Main Cloth', name: 'clothNm', type: 'readOnly' }
    ];
    const m1cloths = [
        { label: 'M1 Cloth', name: 'mtch1Nm', type: 'readOnly' }
    ];
    const m2cloths = [
        { label: 'M2 Cloth', name: 'mtch2Nm', type: 'readOnly' }
    ];
    const m3cloths = [
        { label: 'M3 Cloth', name: 'mtch3Nm', type: 'readOnly' }
    ];

    // console.log(itemSize);
    return (
        <>
            <Titlebar data={CuttingList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Cutting Entry(Contractor)</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memo', type: 'readOnly' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={4}>
                                    <Grid container alignItems="center" spacing={1} sx={{ mt: -1.5, mb: 0.5 }}>
                                        <Grid item style={isDesktop ? { width: '28%' } : { width: '100%' }}>
                                            <FormLabel component="legend">Order Type:</FormLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl component="fieldset" fullWidth>
                                                <RadioGroup row name="ordType" value={formData.ordType} onChange={handleRadioChange}>
                                                    <FormControlLabel value="0" control={<Radio />} label="Manual" />
                                                    <FormControlLabel value="1" control={<Radio />} label="Sale Order" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}


                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {formData.ordType === '1' &&
                                    (<Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sono">Sale Order No:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sono"
                                                        name="sono"
                                                        options={balelist?.clothIssueContSOnos}
                                                        getOptionLabel={(option) => option.sono || ''}
                                                        value={balelist?.clothIssueContSOnos?.find(item => item.sono === formData.sono) || null}
                                                        onChange={(event, newValue) =>
                                                            handleDropdownChange({
                                                                target: { name: 'sono', value: newValue ? newValue.sono : '' } // Ensure consistent controlled behavior
                                                            }, 'sono')
                                                        }
                                                        onOpen={() => handleDropdownOpen('sono')}
                                                        onClose={() => handleDropdownClose('sono')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Select an option"
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.sono === value.sono}
                                                    />
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )}

                                {formData.ordType === '2' &&
                                    (<Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="sono">Sale Order No:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth >
                                                    <Autocomplete
                                                        id="sono"
                                                        name="sono"
                                                        options={balelist?.cuttingSOnos}
                                                        getOptionLabel={(option) => option.sono || ''}
                                                        value={balelist?.cuttingSOnos?.find(item => item.sono === formData.sono) || null}
                                                        onChange={(event, newValue) =>
                                                            handleDropdownChange({
                                                                target: { name: 'sono', value: newValue ? newValue.sono : '' } // Ensure consistent controlled behavior
                                                            }, 'sono')
                                                        }
                                                        onOpen={() => handleDropdownOpen('sono')}
                                                        onClose={() => handleDropdownClose('sono')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="Select an option"
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px', // Set your desired height here
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option.sono === value.sono}
                                                    />
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )}

                                {
                                    formData.ordType === '0' && dropdownlistChallan && dropdownlistChallan?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    formData.ordType === '2' && dropdownDepartment?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}
                                        />
                                    ))
                                }

                                {
                                    formData.ordType === '2' && dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {
                                    formData.ordType === '1' && dropdownlistChallanSO && dropdownlistChallanSO?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {formData.ordType !== '2' && fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    clothState !== true && dropdownClothlist && dropdownClothlist.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {clothState === true && mcloths?.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    clothState === true && dropdownMainClothBale && dropdownMainClothBale?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }



                                {/* {formData.ordType === '0' &&
                                            <Grid item xs={12} md={6}>
                                                <Grid container alignItems="center" spacing={1}>
                                                    <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                        <InputLabel htmlFor='gMtr'>Main Given Mtr.:</InputLabel>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                id='gMtr'
                                                                name='gMtr'
                                                                value={formData.gMtr || ''}
                                                                onChange={handleInputChange}
                                                                inputProps={{ style: styled.input, readOnly: true }}
                                                                sx={inputStyles}
                                                            />
                                                            {errors.gMtr && <FormHelperText style={errorStyles}>{errors.gMtr}</FormHelperText>}
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        } 
                                */}


                                {SOchallan === true &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='gMtr'>Main Given Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='gMtr'
                                                        name='gMtr'
                                                        value={formData.gMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {clothState === true &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='gMtr'>Main Given Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='gMtr'
                                                        name='gMtr'
                                                        value={formData.gMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {[
                                    { label: 'Main Required Mtr.', name: 'rqMtr', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {clothState !== true &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="noofmatch">No of Matching:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="noofmatch"
                                                        name="noofmatch"
                                                        options={noofMatching}
                                                        getOptionLabel={(option) => `${option.label || ''}` || ''}
                                                        value={noofMatching?.find(item => item.value === formData.noofmatch) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'noofmatch', value: newValue ? newValue.value : '' } }, 'noofmatch')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => option && value && option.value === value.value}
                                                        disabled={formData.cloth == ""}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }




                                {
                                    formData.noofmatch >= 1 && clothState !== true && (
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel id="mtch1">Matching-1 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <Autocomplete
                                                            id="mtch1"
                                                            name="mtch1"
                                                            options={soCloth?.filter(item => item.ID !== formData.cloth)}
                                                            getOptionLabel={(option) => `${option.clothNm || ''} `}
                                                            value={soCloth?.find(item => item.ID === formData.mtch1) || null}
                                                            onChange={(event, newValue) => handleDropdownChange({ target: { name: 'mtch1', value: newValue ? newValue.ID : '' } }, 'mtch1')}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    variant="outlined"
                                                                    placeholder='Select an option'
                                                                    sx={{
                                                                        ...inputStyles,
                                                                        '& .MuiInputBase-root': {
                                                                            height: '35px',
                                                                        },
                                                                    }}
                                                                />
                                                            )}
                                                            isOptionEqualToValue={(option, value) => {
                                                                return option && value && option.ID === value.ID;
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }

                                {clothState === true && formData.mtch1 !== '0' && m1cloths?.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    clothState === true && formData.mtch1 !== '0' && dropdownM1ClothBale && dropdownM1ClothBale?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }

                                {/* {formData.noofmatch >= '1' && formData.ordType === '0' &&
                                            <Grid item xs={12} md={6}>
                                                <Grid container alignItems="center" spacing={1}>
                                                    <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                        <InputLabel htmlFor='m1gMtr'>M1 Given Mtr.:</InputLabel>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                id='m1gMtr'
                                                                name='m1gMtr'
                                                                value={formData.m1gMtr || ''}
                                                                onChange={handleInputChange}
                                                                inputProps={{ style: styled.input, readOnly: true }}
                                                                sx={inputStyles}
                                                            />

                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        } 
                                */}

                                {formData.noofmatch >= '1' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1gMtr'>M1 Given Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m1gMtr'
                                                        name='m1gMtr'
                                                        value={formData.m1gMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.noofmatch >= '1' &&

                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m1rqMtr'>Matching-1 Required Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m1rqMtr'
                                                        name='m1rqMtr'
                                                        value={formData.m1rqMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors.m1rqMtr && <FormHelperText style={errorStyles}>{errors.m1rqMtr}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.noofmatch >= '2' && clothState !== true && (
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="mtch2">Matching-2 Cloth:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="mtch2"
                                                        name="mtch2"
                                                        options={soCloth?.filter(item => item.ID !== formData.cloth && item.clothId !== formData.mtch1)}
                                                        getOptionLabel={(option) => `${option.clothNm || ''} `}
                                                        value={soCloth?.find(item => item.ID === formData.mtch2) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'mtch2', value: newValue ? newValue.ID : '' } }, 'mtch2')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => {
                                                            return option && value && option.ID === value.ID;
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}

                                {clothState === true && formData.mtch2 !== '0' && m2cloths?.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    clothState === true && formData.mtch2 !== '0' && dropdownM2ClothBale && dropdownM2ClothBale?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }

                                {/* {formData.noofmatch >= '2' && formData.ordType === '0' &&
                                            <Grid item xs={12} md={6}>
                                                <Grid container alignItems="center" spacing={1}>
                                                    <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                        <InputLabel htmlFor='m2gMtr'>M2 Given Mtr.:</InputLabel>
                                                    </Grid>
                                                    <Grid item xs>
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                id='m2gMtr'
                                                                name='m2gMtr'
                                                                value={formData.m2gMtr || ''}
                                                                onChange={handleInputChange}
                                                                inputProps={{ style: styled.input, readOnly: true }}
                                                                sx={inputStyles}
                                                            />

                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        } */}

                                {formData.noofmatch >= '2' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2gMtr'>M2 Given Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m2gMtr'
                                                        name='m2gMtr'
                                                        value={formData.m2gMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.noofmatch >= '2' &&

                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m2rqMtr'>Matching-2 Required Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m2rqMtr'
                                                        name='m2rqMtr'
                                                        value={formData.m2rqMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors.m2rqMtr && <FormHelperText style={errorStyles}>{errors.m2rqMtr}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                }

                                {formData.noofmatch >= '3' && clothState !== true && (
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="mtch3">Matching-3 Cloth:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Autocomplete
                                                        id="mtch3"
                                                        name="mtch3"
                                                        options={soCloth?.filter(item => item.ID !== formData.cloth && item.clothId !== formData.mtch1 && item.clothId !== formData.mtch2)}
                                                        getOptionLabel={(option) => `${option.clothNm || ''} `}
                                                        value={soCloth?.find(item => item.ID === formData.mtch3) || null}
                                                        onChange={(event, newValue) => handleDropdownChange({ target: { name: 'mtch3', value: newValue ? newValue.ID : '' } }, 'mtch3')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder='Select an option'
                                                                sx={{
                                                                    ...inputStyles,
                                                                    '& .MuiInputBase-root': {
                                                                        height: '35px',
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(option, value) => {
                                                            return option && value && option.ID === value.ID;
                                                        }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}

                                {clothState === true && formData.mtch3 !== '0' && m3cloths?.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    clothState === true && formData.mtch3 !== '0' && dropdownM3ClothBale && dropdownM3ClothBale?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                        />
                                    ))
                                }

                                {/* {formData.noofmatch >= '3' && formData.ordType === '0' &&
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3gMtr'>M3 Given Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            id='m3gMtr'
                                                            name='m3gMtr'
                                                            value={formData.m3gMtr || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: true }}
                                                            sx={inputStyles}
                                                        />

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        } */}

                                {formData.noofmatch >= '3' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m3gMtr'>M3 Given Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m3gMtr'
                                                        name='m3gMtr'
                                                        value={formData.m3gMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {formData.noofmatch >= '3' &&

                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='m3rqMtr'>Matching-3 Required Mtr.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id='m3rqMtr'
                                                        name='m3rqMtr'
                                                        value={formData.m3rqMtr || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors.m3rqMtr && <FormHelperText style={errorStyles}>{errors.m3rqMtr}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                }

                                {[

                                    { label: 'Total Qty.', name: 'totQty', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* {
                                    formData.ordType === '1' && SOchallan === false && dropdownBale?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                } */}

                                {/* {formData.ordType === '2' && SOchallan === false &&
                                    (<Grid item xs={12} md={2}>
                                        <Button variant="contained" color="primary" onClick={handleAddClick} disabled={formData.bale === ""}>Bale Add</Button>
                                    </Grid>)
                                } */}

                                {formData.ordType === '2' && SOchallan === false &&
                                    (<Grid item xs={12} md={2}>
                                        <Button variant="contained" color="primary" onClick={handleRemoveClickSO} disabled={selectedRows.length === 0}>Remove</Button>
                                    </Grid>)}


                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <Grid item xs={10} md={11}>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                <Checkbox
                                                                    checked={tableData.length > 0 && selectedRows.length === tableData.length}
                                                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Cloth Type</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Cloth</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bale No.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Stock Mtr.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Given Mtr.</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bal Mtr.</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {tableData.length > 0 ? (
                                                            tableData.map((item, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        <Checkbox
                                                                            checked={selectedRows.includes(index)}
                                                                            onChange={(e) => handleSelectRow(index, e.target.checked)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.ClothType}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.clothNm}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleNo}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.baleMtr}</TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        <input
                                                                            type="text"
                                                                            value={item.givenMtr}
                                                                            // onChange={(e) => handleGivenMtrChange(index, e.target.value)}
                                                                            style={{ width: '80px', padding: '1px' }}
                                                                            readOnly
                                                                        />
                                                                        <button type='button' className="add" style={{ marginLeft: '10px' }} onClick={() => handleLumpAdd(item.baleId)}>Lump</button>
                                                                    </TableCell>
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                        {calculateBalanceMtr(item.baleMtr, item.givenMtr)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : null}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </>
                                }


                                {itemSize?.length > 0 &&
                                    (
                                        <>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                                <Table>
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Size</TableCell>
                                                        {itemSize?.length > 0 ? itemSize.map((val, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val}</TableCell>
                                                        )) : null}
                                                    </TableRow>

                                                    {formData.ordType !== '0' &&
                                                        (<TableRow>
                                                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>SO Qty.</TableCell>
                                                            {soQty.length > 0 ? soQty.map((val, index) => (
                                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val}</TableCell>
                                                            )) : null}
                                                        </TableRow>)
                                                    }

                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Qty.</TableCell>
                                                        {itemSize.length > 0 ? itemSize.map((val, index) => (
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                                                <input
                                                                    type="text"
                                                                    style={{ width: '40px', padding: '1px' }}
                                                                    value={inputValues[index]}
                                                                    placeholder='0'
                                                                    onChange={(e) => handleQtychange(index, e)}
                                                                />
                                                            </TableCell>
                                                        )) : null}
                                                    </TableRow>


                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>Main Avg.</TableCell>
                                                        {itemMainAvgs?.length > 0 ? itemSize?.map((size, index) => {
                                                            const matchedObj = itemMainAvgs?.find(obj => obj.size === size);
                                                            const avgs = matchedObj?.avg;

                                                            return (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                                                    {avgs !== '0' ? avgs :
                                                                        (<input
                                                                            type="text"
                                                                            style={{ width: '40px', padding: '1px' }}
                                                                            value={mainValues[index] || avgs}
                                                                            onChange={(e) => handleMainValuesChange(index, e)}
                                                                        />)
                                                                    }
                                                                </TableCell>
                                                            )
                                                        }
                                                        ) : null}
                                                    </TableRow>


                                                    {itemM1Avgs.length > 0 &&
                                                        (<TableRow>
                                                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-1 Avg.</TableCell>

                                                            {itemM1Avgs.length > 0 ? itemSize?.map((size, index) => {
                                                                const matchedObj = itemM1Avgs?.find(obj => obj.size === size);
                                                                const avgs = matchedObj?.avg;

                                                                return (
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                                                        {avgs !== '0' ? avgs :
                                                                            (<input
                                                                                type="text"
                                                                                style={{ width: '40px', padding: '1px' }}
                                                                                value={mainValues[index] || avgs}
                                                                                onChange={(e) => handleMainValuesChange(index, e)}
                                                                            />)
                                                                        }
                                                                    </TableCell>
                                                                )
                                                            }
                                                            ) : null}

                                                        </TableRow>)
                                                    }

                                                    {itemM2Avgs.length > 0 &&
                                                        (<TableRow>
                                                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-2 Avg.</TableCell>

                                                            {itemM2Avgs.length > 0 ? itemSize?.map((size, index) => {
                                                                const matchedObj = itemM2Avgs?.find(obj => obj.size === size);
                                                                const avgs = matchedObj?.avg;

                                                                return (
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                                                        {avgs !== '0' ? avgs :
                                                                            (<input
                                                                                type="text"
                                                                                style={{ width: '40px', padding: '1px' }}
                                                                                value={mainValues[index] || avgs}
                                                                                onChange={(e) => handleMainValuesChange(index, e)}
                                                                            />)
                                                                        }
                                                                    </TableCell>
                                                                )
                                                            }
                                                            ) : null}

                                                        </TableRow>)
                                                    }

                                                    {itemM3Avgs.length > 0 &&
                                                        (<TableRow>
                                                            <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px', width: '100px' }} align='center'>M-3 Avg.</TableCell>

                                                            {itemM3Avgs.length > 0 ? itemSize?.map((size, index) => {
                                                                const matchedObj = itemM3Avgs?.find(obj => obj.size === size);
                                                                const avgs = matchedObj?.avg;

                                                                return (
                                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center' key={index}>
                                                                        {avgs !== '0' ? avgs :
                                                                            (<input
                                                                                type="text"
                                                                                style={{ width: '40px', padding: '1px' }}
                                                                                value={mainValues[index] || avgs}
                                                                                onChange={(e) => handleMainValuesChange(index, e)}
                                                                            />)
                                                                        }
                                                                    </TableCell>
                                                                )
                                                            }
                                                            ) : null}
                                                        </TableRow>)
                                                    }
                                                </Table>
                                            </TableContainer>

                                            <Grid item xs={12} md={2}>
                                                <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>
                                            </Grid>
                                        </>
                                    )
                                }

                                {
                                    multiData?.length > 0 &&
                                    <>
                                        <table>
                                            <thead>
                                                <th>Sr.No.</th>
                                                <th>SO No.</th>
                                                <th>Item</th>
                                                <th>Total Qty.</th>
                                                <th>Total Mtr.</th>
                                                <th>View</th>
                                                <th>Delete</th>
                                            </thead>
                                            <tbody>
                                                {multiData.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{data.sono}</td>
                                                        <td>{data.itemNm}</td>
                                                        <td>{data.totQty}</td>
                                                        <td>{data.totmtr}</td>
                                                        <td><Preview className='cursor-pointer' onClick={() => handleViewClick(data)} /></td>
                                                        <td><DeleteIcon className='cursor-pointer' onClick={() => handleDeleteItem(data)} /></td>
                                                    </tr>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td></td>
                                                    <td>Total</td>
                                                    <td>{formData.finalqty}</td>
                                                    <td>{formData.finalmtr}</td>
                                                    <td> </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </>
                                }

                                {[
                                    { label: 'Cutting Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default ContCutEntry3;
